var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7.201,
    height: 12.001,
    viewBox: "0 0 7.201 12.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#26b963",
    d: "M328.864,375.669a.817.817,0,0,1-.259.594l-5.432,5.16a.918.918,0,0,1-1.251,0,.811.811,0,0,1,0-1.188l4.807-4.566-4.806-4.566a.811.811,0,0,1,0-1.189.918.918,0,0,1,1.251,0l5.432,5.16A.817.817,0,0,1,328.864,375.669Z",
    transform: "translate(-321.663 -369.669)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.2926a2f9cd0c54d89095ec01822174e0.svg";
export { ForwardRef as ReactComponent };